import { getEngagementSummary,
    getEngagers,
    getPrescribers } from '../../../redux/thunks/engagementThunks';
import { getTriggers } from '../../../redux/thunks/triggerThunk';
import { getPrescriptionPerformanceByYear } from '../../../redux/thunks/prescriptionThunks';
import { getQualityVisits,
    getTopWebsites,
    getWebMatrixFalse,
    getWebMatrixTrue } from '../../../redux/thunks/webMatrixThunks';

import { handleCustomisationForCompanyDashboard } from '../../../utility';

const fetchDtcDashboardData = (dispatch, companyId, startRange, endRange,resetToInitialState) => {
    const handleWebsitePerformanceChart = [60,170,61,94];
    const isTrue = handleWebsitePerformanceChart.includes(companyId);
    dispatch(
        getTriggers({
            companyId,
            startRange,
            endRange
        })
    );
    dispatch(
        getQualityVisits({
            companyId,
            startRange,
            endRange
        })
    );
    dispatch(
        getTopWebsites({
            companyId,
            startRange,
            endRange
        })
    );
    if(isTrue){
        dispatch(resetToInitialState());
        dispatch(
            getWebMatrixFalse({
                companyId,
                startRange,
                endRange
            })
        );
        dispatch(
            getWebMatrixTrue({
                companyId,
                startRange,
                endRange
            }));
    } else{
        dispatch(
            getPrescriptionPerformanceByYear({
                companyId,
                year: new Date().getFullYear()
            })
        );
    }

};

const fetchHcpDashboardData = (dispatch, companyId, startRange, endRange, engagerCompanies, resetToInitialState) => {
    dispatch(
        getEngagementSummary({
            companyId,
            startRange,
            endRange
        })
    );
    dispatch(
        getTriggers({
            companyId,
            startRange,
            endRange
        })
    );

    if (handleCustomisationForCompanyDashboard(companyId)) {
        dispatch(resetToInitialState());

        dispatch(
            getEngagers({
                companyId,
                startRange,
                endRange,
                size: 10
            })
        );
        dispatch(
            getWebMatrixFalse({
                companyId,
                startRange,
                endRange
            })
        );
        dispatch(
            getWebMatrixTrue({
                companyId,
                startRange,
                endRange
            })
        );
    } else {
        if (engagerCompanies.includes(companyId)) {
            dispatch(
                getEngagers({
                    companyId,
                    startRange,
                    endRange,
                    size: 10
                })
            );
        } else {
            dispatch(
                getPrescribers({
                    companyId,
                    startRange,
                    endRange
                })
            );
        }
        dispatch(
            getPrescriptionPerformanceByYear({
                companyId,
                year: new Date().getFullYear()
            })
        );
    }
};

export const fetchDashboardData = ({
    dispatch,
    companyId,
    startRange,
    endRange,
    engagerCompanies,
    resetToInitialState,
    isOmaniChannel
}) => {
    if (!companyId) return;
    if (!isOmaniChannel) {
        fetchHcpDashboardData(dispatch, companyId, startRange, endRange, engagerCompanies, resetToInitialState);
    }
    if (isOmaniChannel) {
        fetchDtcDashboardData(dispatch, companyId, startRange, endRange, resetToInitialState);
    }
};
